export default __webpack_public_path__ + "static/media/harvestsoul.c8625ba1.png";